import * as React from 'react';

var useCalendarHeader = function useCalendarHeader() {
  var prevButtonRef = React.useRef(null);
  var nextButtonRef = React.useRef(null);
  var buttonSize = {
    height: '36px',
    width: '36px'
  };
  return {
    prevButtonRef: prevButtonRef,
    nextButtonRef: nextButtonRef,
    buttonSize: buttonSize
  };
};

export { useCalendarHeader };
//# sourceMappingURL=useCalendarHeader.js.map
